import React from 'react';
import classes from './LinearGauge.module.scss';
import { ApIcon } from '@alixpartners/ui-components';
import { dataVizColors } from 'styles/colors';

const LinearGauge = props => {
	const { values } = props;
	const { min, max, median } = values;
	const transformScale = value => {
		return ((value - min) / (max - min)) * 100;
	};

	let showMinWarning,
		showMaxWarning = false;
	let warningTooltip = '';

	let scaledMedian = Number(transformScale(median).toFixed(2));
	scaledMedian = Math.abs(scaledMedian);

	// const isRoot = level === 1 && group === 1;

	return (
		<div className={`${classes.linear_gauge} ${classes.linear_gauge__marker}`}>
			<div
				className={classes.linear_gauge__median}
				style={{
					'--custom-median-position': `${scaledMedian}%`,
					// display: `${isRoot && 'none'}`,
				}}
			/>
			<div
				className={classes.linear_gauge__medianValue}
				style={{
					'--custom-median-position': `${
						scaledMedian === 100 ? 98 : scaledMedian - 1
					}%`,
					// display: `${isRoot && 'none'}`,
				}}
			>
				{median}
			</div>
			{showMinWarning && (
				<div
					className={classes.warning_min}
					// style={{ display: `${isRoot && 'none'}` }}
				>
					<span title={warningTooltip}>
						<ApIcon
							iconName="outline_error"
							iconSize="24px"
							iconColor={dataVizColors.orange}
						/>
					</span>
				</div>
			)}
			{showMaxWarning && (
				<div
					className={classes.warning_max}
					// style={{ display: `${isRoot && 'none'}` }}
				>
					<span title={warningTooltip}>
						<ApIcon
							iconName="outline_error"
							iconSize="24px"
							iconColor={dataVizColors.orange}
						/>
					</span>
				</div>
			)}
		</div>
	);
};

export default LinearGauge;
